import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

import { TypographyFontSize, TypographyColor } from '@design-system/components/atoms/typography/entities/typography.types';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';

@Component({
  selector: 'app-edit-form-default',
  templateUrl: './edit-form-default.component.html',
  styleUrls: ['./edit-form-default.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EditFormDefaultComponent {

  @Output() clickDelete: EventEmitter<void> = new EventEmitter<void>();

  public readonly iconEdit = Icon.EditOutline;
  public readonly typographyFontSize = TypographyFontSize;
  public readonly typographyColor = TypographyColor;

  constructor() { }

}
